import request from '/@/utils/request'
import { Ref } from 'vue'
import type {
	Verify,
	LoginForm,
	AreaCode,
	NotPass,
	SmsPar,
	Register,
	ModifyPassword,
	LoginData,
	SmsCode,
} from '../types/login'
import { Res } from '/@/types/common'

//获取验证码
export const getVerify = (loading: Ref<boolean>) => {
	return request({
		url: '/verify',
		loading,
	}) as Promise<Res<Verify>>
}

//用户登录
export const login = (data: LoginForm, loading: Ref<boolean>) => {
	return request({
		url: '/login',
		method: 'POST',
		data,
		loading,
	}) as Promise<Res<LoginData>>
}

//获取区号
export const getAreacode = (loading: Ref<boolean>) => {
	return request({
		url: '/areacode',
		loading,
	}) as Promise<Res<AreaCode[]>>
}

//忘记密码
export const forgetPass = (data: NotPass, loading: Ref<boolean>) => {
	return request({
		url: '/forgetpassword',
		method: 'POST',
		data,
		loading,
	})
}

//获取短信验证码
export const getSmsCode = (params: SmsPar, loading?: Ref<boolean>) => {
	return request({
		url: '/smscode',
		params,
		loading,
	}) as Promise<Res<SmsCode>>
}

//注册
export const register = (data: Register, loading: Ref<boolean>) => {
	return request({
		url: '/register',
		method: 'POST',
		data,
		loading,
	}) as Promise<Res<string>>
}

//修改密码
export const modifyPassword = (data: ModifyPassword, loading: Ref<boolean>) => {
	return request({
		url: '/modifypassword',
		method: 'POST',
		data,
		loading,
	})
}

export const getLimit = (loading?: Ref<boolean>) => {
	return request<any>({
		url: '/storenamelimit',
		loading,
	})
}

export const getCategorys = (params: any, loading?: Ref<boolean>) => {
	return request<any>({
		url: '/category',
		loading,
		params,
	})
}
